<template>
    <div v-show="visable && rechargeSuccessAccount.length" class="account-history">
        <div class="line-wrapper">
            <div class="line"></div>
        </div>
        <div class="wrapper" @click.stop>
            <div class="title">猜您想充值的号码</div>
            <ul class="recharge-accounts">
                <li
                    v-for="(account, index) in rechargeSuccessAccount"
                    :key="index"
                    :class="['account', { active: current === account }]"
                    @click="choose(account)"
                >
                    {{ account | formatAccount }}
                    <i class="input-close" @click.stop="hiddenSuccessAccount(index)" />
                </li>
            </ul>
            <!-- <a class="clear-btn" @click.prevent="clearAccountHistory">清空历史记录</a> -->
        </div>
        <!-- <div class="fake-mask"></div> -->
    </div>
</template>

<script>
import { getRechargeSuccessAccount, hiddenSuccessAccount } from '../../../api';
import { lock, unlock } from 'tua-body-scroll-lock';
import env from '@/common/util/env';

export default {
    props: {
        current: {
            type: String,
            default: '',
        },
        visable: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: '',
        },
        productId: String,
    },
    data() {
        return {
            rechargeSuccessAccount: [],
        };
    },
    watch: {
        visable(newVal) {
            const { productId, rechargeSuccessAccount } = this;
            const scrollDom = document.querySelector('.recharge-accounts');
            if (newVal) {
                !rechargeSuccessAccount.length && this.updateAccountHistory(productId);
                env.isIos ? lock(scrollDom) : lock();
            } else {
                env.isIos ? unlock(scrollDom) : unlock();
            }
        },
    },
    filters: {
        formatAccount(val) {
            if (/^(1\d{2})(\d{4})(\d{4})$/.test(val)) {
                return `${RegExp.$1} ${RegExp.$2} ${RegExp.$3}`;
            }
            return val;
        },
    },
    methods: {
        show() {
            this.$emit('update:visable', true);
        },
        hide() {
            this.$emit('update:visable', false);
        },
        async updateAccountHistory(productId) {
            const { data, code } = await getRechargeSuccessAccount({ productId });
            if (code === 0) {
                const { rechargeSuccessAccount } = data || {};
                this.rechargeSuccessAccount = rechargeSuccessAccount || [];
                if (!rechargeSuccessAccount.length) {
                    const scrollDom = document.querySelector('.recharge-accounts');
                    const el = document.querySelector('.btn-area');
                    env.isIos ? unlock(scrollDom) : unlock();
                    el.style.position = 'fixed';
                }
            }
        },
        async hiddenSuccessAccount(index) {
            const account = this.rechargeSuccessAccount[index];
            await hiddenSuccessAccount({
                productId: this.productId,
                account,
            });
            this.rechargeSuccessAccount.splice(index, 1);
        },
        choose(account) {
            let formatAccount = account;
            if (this.type === 'phone') {
                formatAccount = this.toFormatPhone(account);
            }
            this.$emit('update:current', formatAccount);
            // setTimeout(() => this.hide(), 200); // ? input失焦事件来隐藏
        },
        toFormatPhone(phone) {
            const arr = phone.split('');
            if (arr.length > 3) {
                arr.splice(3, 0, ' ');
            }
            if (arr.length > 8) {
                arr.splice(8, 0, ' ');
            }
            return arr.join('');
        },
    },
};
</script>

<style lang="scss" scoped>
@keyframes fade-in {
    from {
        opacity: 0;
    }
}
.account-history {
    position: absolute;
    z-index: 10;
    left: -0.24rem;
    top: 1.94rem;
    min-height: 100vh;
    .line-wrapper {
        position: absolute;
        top: 0;
        width: 6.54rem;
        padding: 0 0.48rem;
        z-index: 11;
        .line {
            background: #f0f0f0;
            width: 100%;
            height: 1px;
        }
    }
    &.game {
        top: 2.47rem;
    }
    .fake-mask {
        background: rgba(0, 0, 0, 0.7);
        animation: fade-in 0.3s linear;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
    }
    .wrapper {
        top: -0.12rem;
        transform: scale(1); // ? 破坏fixed的相对参照
        z-index: 10;
        position: relative;
        background: #ffffff;
        margin: 0 0.24rem;
        box-shadow: 0rem 0.2rem 0.24rem 0rem rgba(0, 0, 0, 0.08);
        border-radius: 0rem 0rem 0.16rem 0.16rem;
        .title {
            box-sizing: border-box;
            width: 7.02rem;
            background: #fff;
            font-size: 0.28rem;
            line-height: 0.4rem;
            color: #999999;
            padding: 0.24rem;
            padding-bottom: 0.08rem;
        }
        .recharge-accounts {
            list-style: none;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width: 7.02rem;
            padding: 0 0.3rem;
            box-sizing: border-box;
            animation: fade-in 0.3s linear;
            font-family: FinancialNumber;
            max-height: 3.06rem;
            /*iPhone5和iPhone SE*/
            @media only screen and (device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) {
                max-height: 2.8rem;
            }

            /* iPhone6/7/8 */
            @media only screen and (device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) {
                max-height: 2.8rem;
            }

            /*iPhone6 Plus 和iPhone8 Plus*/
            @media only screen and (device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) {
                max-height: 2.8rem;
            }

            // /* iPhone6/7/8 Plus*/
            // @media only screen and (device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) {
            //     max-height: 3.9rem;
            // }

            // /* iPhoneX*/
            // @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
            //     max-height: 3.9rem;
            // }

            overflow-y: auto;
            .account {
                width: 100%;
                height: 0.96rem;
                background: #ffffff;
                font-family: FinancialNumber;

                font-size: 0.56rem;
                font-weight: 600;
                color: #333333;
                line-height: 0.96rem;

                position: relative;
                &:after {
                    content: '';
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    height: 0.01rem;
                    transform-origin: 0 0;
                    background-color: #f0f0f0;
                }
                &:last-child {
                    &:after {
                        display: none;
                    }
                }
                .input-close {
                    position: absolute;
                    top: 0.24rem;
                    right: 0;
                    width: 0.48rem;
                    height: 0.48rem;
                    background: url('../../../images/icon-input-delete-V2.png');
                    background-size: 100%;
                }
            }
        }
    }
}
</style>
